import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProducts = async () => (await api.get("/products")).data;
export const fetchProduct = async (id) => (await api.get(`/products/${id}`)).data;
export const submitContact = async (payload) => (await api.post("/contact", payload)).data;
export const createCheckout = async (payload) => (await api.post("/checkout/session", payload)).data;
export const getCheckoutStatus = async (sessionId) =>
  (await api.get(`/checkout/status/${sessionId}`)).data;
